global.Buffer = require('buffer').Buffer;
